var map = {
	"./locales/ar copy.json": 51251,
	"./locales/ar.json": 5310,
	"./locales/de.json": 95894,
	"./locales/en copy.json": 69571,
	"./locales/en.json": 44174,
	"./locales/en2.json": 29904,
	"./locales/sidebar.json": 34375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47733;